/**
 * LANDING PAGE COMPONENT - DO NOT USE IN APP
 *
 * Component: Header
 * Purpose: Landing page header with navigation and login button
 * Location: /src/landing/components/Header.tsx
 *
 * This is the LANDING PAGE header component.
 * For app header, see: /src/components/Layout.js
 */

// import { LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/60 backdrop-blur-md border-b border-border/20">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <span className="text-2xl font-serif font-semibold text-foreground">Concierge.</span>
        {/* <nav className="hidden md:flex items-center gap-6">
          <a href="#features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Features
          </a>
          <a href="#services" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Services
          </a>
        </nav> */}
        <Button variant="default" size="sm" className="gap-2 px-7 h-[2.5rem]" asChild>
          <Link to="/login">
            {/* <LogIn className="w-4 h-4" /> */}
            Login
          </Link>
        </Button>
      </div>
    </header>
  );
};

export default Header;
